import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./App.css";
import React, { lazy, Suspense } from "react";
import loading from "src/assets/icons/loading.svg";
import { createHashRouter, RouterProvider } from "react-router-dom";
import SideBar from "src/layouts/sidebar/index";
import DomainsList from "./pages/list/domains";
import {AlertProvider, AppProvider, EndpointProvider, BackendProvider}  from "src/contexts"
import AuthserverList from "./pages/list/authservers";
const Endpoints = lazy(() => import("./pages/dashboard/enpoints"));
const EndpointsList = lazy(() => import("./pages/list/endpoinds"));
const EndpointDetail = lazy(() => import("./pages/details/endpoint"));
const HomePage = lazy(() => import("./pages/main"));
// const GatewayDetails = lazy(() => import("./pages/details/gateway"));
const GatewaysList = lazy(() => import("./pages/list/gateways"));
const NotFound = lazy(() => import("./pages/notFound"));

const theme = createTheme({
  palette: {
    primary: {
      main: "#3490dc",
    },
  },
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          "& .MuiSvgIcon-root": {
            color: "#d9dde3",
          },
          "&.Mui-checked .MuiSvgIcon-root": {
            color: "#3490dc",
          },
        },
      },
    },
  },
});
const router = createHashRouter(
  [
    { path: "/domains", element: <DomainsList /> },
    { path: "/endpoints", element: <Endpoints /> },
    { path: "", element: <HomePage /> },
    { path: "/endpoints/list", element: <EndpointsList /> },
    { path: "/endpoints/:id/:envId", element: <EndpointDetail /> },
    { path: "/gateways", element: <GatewaysList /> },
    { path: "/gateways/list", element: <GatewaysList /> },
    // { path: "/gateways/:id", element: <GatewayDetails /> },
    { path: "/authservers", element: <AuthserverList /> },
    { path: "/authservers/list", element: <AuthserverList /> },
    { path: "*", element: <NotFound /> },
  ],
  {
    future: {
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_relativeSplatPath: true,
      v7_skipActionErrorRevalidation: true,
    },
  }
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AppProvider>
        <EndpointProvider>
          <BackendProvider>
            <AlertProvider>
              <main className="flex max-w-[100%] overflow-hidden h-screen">
                <SideBar />
                <div className="w-[100%] max-h-[98%] m-[10px] overflow-y-auto b-[#fff] scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-400">
                  <Suspense
                    fallback={
                      <div className="flex justify-center items-center h-full">
                        <img src={loading} alt="" className="w-[6rem] pb-2" />
                      </div>
                    }
                  >
                    <RouterProvider
                      router={router}
                      future={{
                        v7_startTransition: true,
                      }}
                    ></RouterProvider>
                  </Suspense>
                </div>
              </main>
            </AlertProvider>
          </BackendProvider>
        </EndpointProvider>
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;
